module.exports = __webpack_public_path__ + "4fe6f9caff8b287170d51d3d71d5e5c6.ttf";